import React from "react";
import SliderCarousel from "../components/SliderCarouselsingle";
import FeatureBox from "../components/FeatureBox";
import Footer from "../components/footer";
import { createGlobalStyle } from "styled-components";
import Reveal from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
// import { ViewArtwork } from "../components/ViewArtwork";

const fadeInUp = keyframes`
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    transform: translateY(40px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
`;
const inline = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
  .d-inline{
    display: inline-block;
   }
`;

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar .search #quick_search{
    background: rgba(255, 255, 255, .1);
  }
  header#myHeader .logo .d-block{
    display: none !important;
  }
  header#myHeader .logo .d-none{
    display: none !important;
  }
  header#myHeader .logo .d-3{
    display: block !important;
  }
  footer.footer-light .subfooter span img.d-1{
    display: none !important;
  }
  footer.footer-light .subfooter span img.d-3{
    display: inline-block !important;
  }
  .de_countdown{
    right: 10px;
  }
  .author_list_pp{
    margin-left:0;
  }
  footer.footer-light .subfooter{
    border-top: 1px solid rgba(255,255,255,.1);
  }
`;

const home = () => (
  <div>
    <GlobalStyles />
    <section className="jumbotron no-bg">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="spacer-single"></div>
            <Reveal
              className="onStep"
              keyframes={fadeInUp}
              delay={0}
              duration={600}
              triggerOnce
            >
              <h2>
                <span className="text-uppercase color">Copycats</span>
              </h2>
              <p className=" lead">Proof of Originality</p><br />
            </Reveal>
            <div className="spacer-10"></div>
            <Reveal
              className="onStep"
              keyframes={fadeInUp}
              delay={300}
              duration={600}
              triggerOnce
            >
              <h1>
                Create
                <br />
                Attest
                <br />
                Transact
                <br />
                Store
              </h1>
            </Reveal>
            <Reveal
              className="onStep"
              keyframes={fadeInUp}
              delay={600}
              duration={600}
              triggerOnce
            >
              <p className=" lead">
                Register & trade your original artworks on Blockchain
              </p>
            </Reveal>
            <div className="spacer-10"></div>
            <Reveal
              className="onStep"
              keyframes={fadeInUp}
              delay={800}
              duration={900}
              triggerOnce
            >
              <span
                onClick={() => window.open("/create", "_self")}
                className="btn-main lead"
              >
                Claim Originality
              </span>
              <div className="mb-sm-30"></div>
            </Reveal>
            <Reveal
              className="onStep d-inline"
              keyframes={inline}
              delay={900}
              duration={1200}
              triggerOnce
            >
              <div className="row">
                <div className="spacer-single"></div>
              </div>
            </Reveal>
            <div className="spacer-double"></div>
          </div>
          <div className="col-lg-6 px-0">
            <SliderCarousel />
          </div>
        </div>
      </div>
    </section>

    <section className="container no-top">
      <div className="container px-0">
        <FeatureBox />
      </div>
    </section>

    <Footer />
  </div>
);
export default home;
